import storeRoot from '../store-root'
import http from '../../services/http'

const moduleName = 'paramer'

storeRoot.registerModule(moduleName, {
  namespaced: true,
  state: {

  },
  actions: {
    // 获取水质参数曲线数据
    async getParamerData ({ commit }, payload) {
      let result = await http.post(
        `/api/Equipment/GetHistoricalData
      `,
        payload
      )
      return result.data
    }

    // async
    // /api/Equipment/ExportSensorHistoryData

  },
  mutations: {
  }

})

export default moduleName
